export enum LeaverMeterCollectionScope {
    All = 'all',
    None = 'none',
    OnlySales = 'onlySales',
    OnlyRental = 'onlyRental',
}
